
import Vue from "vue";
import App from "./App";
import router from "./router";
import "vue-layer-mobile/need/layer.css";
import layer from "vue-layer-mobile";
import VueLocalStorage from "vue-localstorage";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./common/font/iconfont.css";
import "./common/css/body.css";
import ViewUI from "view-design";
import "view-design/dist/styles/iview.css";
import LuckDraw from "vue-luck-draw";
import WebIM from "./utils/WebIM";
import "video.js/dist/video-js.css";
import videojs from "video.js";
import util from "./common/js/util";
import qs from "qs";
import wx from 'weixin-js-sdk'
import VueWechatTitle from "vue-wechat-title";
import store from "./store/store";
import vHeader from "./common/vue/head.vue";
import {
  Button, Toast, Icon, Swipe, SwipeItem, NoticeBar, Lazyload, List, Overlay, Loading, Badge, Field, Dialog, Popup, Stepper,
  CountDown, Rate, Uploader, RadioGroup, Radio, Cascader, Checkbox, CheckboxGroup, ActionSheet, Cell, Calendar, PasswordInput,
  NumberKeyboard, Step, Steps, PullRefresh, AddressList, AddressEdit, Switch, DropdownMenu, DropdownItem, Search, ShareSheet,
  Progress, CellGroup, Col, Row, ImagePreview,Sidebar, SidebarItem,Empty ,NavBar,GoodsAction, GoodsActionIcon, GoodsActionButton,
  Area,Pagination,DatetimePicker,Form ,Image as VanImage
} from 'vant';
Vue.use(Button).use(Icon).use(Toast).use(Swipe).use(SwipeItem).use(NoticeBar).use(Lazyload).use(List).use(Overlay).use(Loading)
  .use(Badge).use(Field).use(Dialog).use(Popup).use(Stepper).use(CountDown).use(Rate).use(Uploader).use(RadioGroup).use(Radio)
  .use(Cascader).use(Checkbox).use(CheckboxGroup).use(ActionSheet).use(Cell).use(Calendar).use(PasswordInput).use(NumberKeyboard)
  .use(Step).use(Steps).use(PullRefresh).use(AddressList).use(AddressEdit).use(Switch).use(DropdownMenu).use(DropdownItem)
  .use(Search).use(ShareSheet).use(Progress).use(CellGroup).use(Col).use(Row).use(ImagePreview).use(Sidebar).use(SidebarItem)
  .use(Empty).use(NavBar).use(GoodsAction).use(GoodsActionIcon).use(GoodsActionButton).use(Area).use(Pagination).use(DatetimePicker)
  .use(Form).use(VanImage)
// 注册时可以配置额外的选项
Vue.use(Lazyload, {
  lazyComponent: true
});
// //配全局属性配置，在任意组件内可以使用this.$qs获取qs对象
Vue.prototype.$qs = qs;
Vue.prototype.imgUrl = util.imageUrl1;
Vue.prototype.Url = util.userUrl;
Vue.prototype.$wx = wx;
Vue.component("v-header",vHeader)
Vue.use(ViewUI);
Vue.use(Badge);
Vue.use(ElementUI);
Vue.use(VueWechatTitle);
Vue.use(VueAwesomeSwiper);
Vue.use(VueLocalStorage);
Vue.use(layer);
window.videojs = videojs;
Vue.use(LuckDraw);
Vue.config.productionTip = false;
new Vue({
  el: "#app",
  router,
  store,
  WebIM,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js